import React from "react";
import "../App.css";
export const Link02 = () => {
  return (
    <div className="Section01">
      <img src="https://images.unsplash.com/photo-1636953056323-9c09fdd74fa6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxleHBsb3JlLWZlZWR8MXx8fGVufDB8fHx8fA%3D%3D&w=1000&q=80"></img>
      <div className="text_box">
        <p>단순 홈페이지</p>
        <h2>정보마당 페이지 입니다.</h2>
      </div>
    </div>
  );
};
export default Link02;
